import React from 'react';
import './UserIcon.css'

const UserIcon = ({user}) => (
  <div className='user-icon'>{((user || {}).firstname || ' ').charAt(0).toUpperCase()}{((user || {}).lastname || ' ').charAt(0).toUpperCase()}</div>
);

export default UserIcon;
